import React from 'react';

export default function Pizza() {
	// 3
	let style = {
		st25: {
 			fill:"#EAB049"
		},
		st26: {
 			fill:"#C64A4A"
		},
		st27: {
 			fill:"#FFEBCC"
		},
		st24: {
 			fill:"#FC5959"
		}
	};
	return (
		<g>
			<path style={style.st25} d="M93.449585,360.7979431c-32.8293724-0.0900879-65.2832489,15.8638306-74.3684998,44.7933655
				c-3.5913601,11.4353943,16.6695995,16.3152771,20.2570515,4.8922729
				c6.6102524-21.0485535,30.6053238-31.3465881,54.1114502-31.282196
				C106.9686584,379.2386169,106.9873428,360.8351746,93.449585,360.7979431z"/>
			<path style={style.st25} d="M122.630867,430.7028503l-93.8735809-13.6578064l1.2475014-8.9124146l94.9430237,14.1077881
				l-1.0529938,7.5282593C123.809433,430.3790588,123.2394485,430.8003235,122.630867,430.7028503z"/>
			<path style={style.st26} d="M43.0656281,410.9189453l81.2091217,11.9504089
				c0.4657364,0.0685425,0.8183975-0.4118652,0.6134491-0.8356628l-22.5928192-46.7185669
				c-1.6992035-3.5184631-12.4565887-2.2776489-16.7198257-1.4729919
				c-26.0542336,4.9170227-36.3756218,13.256897-46.816227,30.3744812c-0.0099258,0.0162659-0.0200539,0.0343018-0.0287971,0.051239
				C35.7809753,409.9778137,39.5554504,410.3791809,43.0656281,410.9189453z"/>
			<path style={style.st27} d="M124.8883209,422.0336914l-19.8499298-41.0464783
				c-0.0238647,0.0016174-0.0482788,0.0049438-0.0721436,0.0066223c-0.9145737-1.5110474-2.8769531-0.5892944-5.2914047-0.327179
				c-6.3521042,0.6896057-12.6339035-0.9416809-18.8935242,0.3615723c-5.8088455,1.2093201-9.8267822,4.6444092-13.8734741,8.7596436
				c-7.2775269,7.4005432-22.3308296,10.6604004-18.4959679,24.221283
				c1.8608818,6.5802002,11.0437698,4.9924316,11.9656677-0.5426636l13.2895241,1.9555969
				c0.6501236,2.3100281,2.525383,4.222168,5.639595,4.222168c2.3686142,0,4.0195618-1.1122131,4.962616-2.6619263
				l40.0055313,5.8870239C124.7405014,422.9378967,125.0930939,422.457489,124.8883209,422.0336914z"/>
			<path style={style.st24} d="M102.6781158,393.940918c2.9031754,0,5.5504532-0.8057251,7.5847321-2.1281433l-7.3689117-15.2581787
				c-0.0725937-0.0010681-0.1429825-0.0083313-0.2158203-0.0083313c-6.4044495,0-11.596344,3.8939819-11.596344,8.6973267
				S96.2736664,393.940918,102.6781158,393.940918z"/>
			<ellipse style={style.st24} cx="66.6375046" cy="398.3991089" rx="11.596426" ry="8.6972599"/>
			<path style={style.st24} d="M99.6747208,406.3655701c-6.4044418,0-11.596344,3.8937988-11.596344,8.6973267
				c0,0.8928528,0.1974945,1.7480774,0.5328293,2.5583191l20.0125885,2.9449463
				c1.6444321-1.4999695,2.647522-3.4096069,2.647522-5.5032654
				C111.2713165,410.2593689,106.0794144,406.3655701,99.6747208,406.3655701z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Pizza.js